var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transaction",
    transform: "translate(-85 -859.458)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2205",
    "data-name": "Rectangle 2205",
    width: 32,
    height: 32,
    transform: "translate(85 859.458)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-invoice-dollar",
    "data-name": "Icon awesome-file-invoice-dollar",
    d: "M15.609,4.347,11.555.29a.993.993,0,0,0-.7-.29H10.6V5.3h5.3V5.047A.99.99,0,0,0,15.609,4.347ZM9.274,5.631V0H.994A.991.991,0,0,0,0,.994V20.2a.991.991,0,0,0,.994.994H14.9A.991.991,0,0,0,15.9,20.2V6.624H10.268A1,1,0,0,1,9.274,5.631ZM2.65,2.981a.331.331,0,0,1,.331-.331H6.293a.331.331,0,0,1,.331.331v.662a.331.331,0,0,1-.331.331H2.981a.331.331,0,0,1-.331-.331Zm0,3.312V5.631A.331.331,0,0,1,2.981,5.3H6.293a.331.331,0,0,1,.331.331v.662a.331.331,0,0,1-.331.331H2.981A.331.331,0,0,1,2.65,6.293ZM8.612,17.218v1a.331.331,0,0,1-.331.331H7.618a.331.331,0,0,1-.331-.331V17.211a2.371,2.371,0,0,1-1.3-.47.332.332,0,0,1-.024-.5l.486-.464a.34.34,0,0,1,.419-.03A1,1,0,0,0,7.4,15.9H8.565a.521.521,0,0,0,.489-.546.54.54,0,0,0-.363-.527l-1.863-.559a1.874,1.874,0,0,1-1.307-1.8A1.844,1.844,0,0,1,7.286,10.6v-1a.331.331,0,0,1,.331-.331H8.28a.331.331,0,0,1,.331.331v1.006a2.367,2.367,0,0,1,1.3.47.332.332,0,0,1,.024.5l-.486.464a.34.34,0,0,1-.419.03.993.993,0,0,0-.531-.154H7.333a.521.521,0,0,0-.489.546A.54.54,0,0,0,7.208,13l1.863.559a1.874,1.874,0,0,1,1.307,1.8A1.843,1.843,0,0,1,8.612,17.218Z",
    transform: "translate(93 864.458)",
    fill: "#fff",
    opacity: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.7141f393e6cdf18460320b3423b72d3e.svg";
export { ForwardRef as ReactComponent };